module.exports = __webpack_public_path__ + "8f241aa4.webp";